import { compact, includes } from 'lodash/fp';

import { Offer } from '../../../types';

const sortOffersByProductType = (offers: Offer[]) => {
  const extrasOnlyOffer = offers.find((offer) => includes('extras-only', offer?.identifier?.current));
  const hospitalOnlyOffer = offers.find((offer) => includes('hospital-only', offer?.identifier?.current));
  const hospitalAndExtrasOffer = offers.filter((offer) => offer !== extrasOnlyOffer && offer !== hospitalOnlyOffer);

  return compact([...hospitalAndExtrasOffer, extrasOnlyOffer, hospitalOnlyOffer]);
};

export default sortOffersByProductType;
